export default "__VITE_ASSET__F1_4kVhg__"